import React from "react";
import PropTypes from "prop-types";
import Grid from "canvas-core-react/lib/Grid";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import TextField from "canvas-core-react/lib/TextField";
//import { useTranslation } from 'react-i18next';
import "../../../../../resources/components/public/utils/custom.css";
import { useTranslation } from "react-i18next";

const SettlementAccount = ({ index, account }) => {
  const { t } = useTranslation();

  const { title, details } = {
    title: t("providers.profile.settlement"),
    details: t("general.provider_account_detail", { returnObjects: true }),
  };

  const accountType = {
    BNS: t("selects.national_bns"),
    LOCAL: t("selects.national_local"),
    INT: t("selects.international"),
  };

  return (
    <>
      {index !== 0 ? (
        <div className="custom-flex-space">
          <h3 className="flex-element">{title}</h3>
        </div>
      ) : null}
      <div className="content-info">
        <Grid fluid={true}>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="accountType"
                id="accountType"
                disabled={true}
                value={accountType[account?.accountType] || ""}
                label={details.account_type}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="bicDestinationBank"
                id="bicDestinationBank"
                value={account?.bicDestinationBank || ""}
                disabled={true}
                label={details.destinatin_bic}
              />
            </Column>
          </Row>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="accountNumber"
                id="accountNumber"
                value={account?.accountNumber || ""}
                label={details.account_number}
                disabled={true}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="bicIntermediaryBank"
                id="bicIntermediaryBank"
                value={account?.bicIntermediaryBank || ""}
                label={details.intermediary_bank}
                disabled={true}
              />
            </Column>
          </Row>
          <Row justifyContent="spaceBetween">
            <Column lg={5} md={5}>
              <TextField
                name="accountIntermediaryBank"
                id="accountIntermediaryBank"
                value={account?.accountIntermediaryBank || ""}
                label={details.intermediary_account}
                disabled={true}
              />
            </Column>
            <Column lg={5} md={5}>
              <TextField
                name="accountCurrency"
                id="accountCurrency"
                value={account?.accountCurrency || ""}
                label={details.currency}
                disabled={true}
              />
            </Column>
          </Row>
        </Grid>
      </div>
    </>
  );
};

SettlementAccount.propTypes = {
  account: PropTypes.object.isRequired,
};

export default SettlementAccount;
